
import { PAGES } from "@/common/consts";

/**
 * @TODO 	This code has been migrated from the Vue site as it is, as the scope of the ticket is too narrow
 * 			and making any refactor on in right now its not possible. However, we may want to make this
 * 			a bit more less messy, as right now can get a bit confusing. For now its fine as this works on its own
 * 			and can be placed anywhere where the routes below apply and wont have any significant impact
 * 			on the rest of the site.
 */

export default {
	name: "RelatedLinks",
	data() {
		return {
			links: [
				{
					title: "Words With Friends Cheat",
					url: "/words-with-friends-cheat/",
				},
				{ title: "Wordle Helper", url: "/wordle/" },
				{ title: "NYT Crossplay Cheat", url: "/nyt-crossplay/" },
				{ title: "Word Unscrambler", url: "/unscramble/" },
				{ title: "Word Finder", url: "/" },
				{
					title: "Words Containing Letters",
					url: "/words-with-the-letter/",
				},
			],
		};
	},
	computed: {
		showList() {
			switch (this.$route.name) {
				case PAGES.UNSCRAMBLER_RESULTS:
				case PAGES.SCRABBLE_DICT_RESULTS:
				case PAGES.WORDS_HAVING_INDEX:
				case PAGES.WORDS_STARTING_INDEX:
				case PAGES.WORDS_ENDING_INDEX:
				case PAGES.WORDS_BY_LENGTH_INDEX:
				case PAGES.WORDS_VOWELS:
				case PAGES.WORDS_CONSONANTS:
				case PAGES.WORDS_WITH_Q_NO_U:
				case PAGES.WORDS_ENDING_ING:
				case PAGES.WORDS_HAVING_RESULTS:
				case PAGES.WORDS_STARTING_RESULTS:
				case PAGES.WORDS_ENDING_RESULTS:
				case PAGES.WORDS_COMBINATION_LETTERS_RESULTS:
				case PAGES.WORDS_BY_LENGTH_RESULTS:
				case PAGES.WORDS_COMBINATION_LENGTH_AND_LETTERS_RESULTS:
				case PAGES.ARTICLE_INDEX:
				case PAGES.ARTICLE_DETAIL:
				case PAGES.WORDLE_ARTICLES_INDEX:
				case PAGES.WORDLE_ARTICLE_DETAIL:
				case PAGES.GAME_CHEATS:
				case PAGES.WORDS_LISTS_INDEX:
					return true;
				default:
					return false;
			}
		},
	},
};
